import { upperFirst, lowerCase, startCase, camelCase } from 'lodash'

export const sentenceCase = (word?: string): string => {
  return upperFirst(lowerCase(word))
}

export const titleCase = (sentence: string): string => {
  return startCase(camelCase(sentence))
}
